import React from 'react'
import { Input } from 'antd'
import styles from './style.module.scss'

interface InputFieldProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  isQuarter?: boolean
  useTextArea?: boolean
}

function InputField({
  id,
  label,
  value,
  onChange,
  isQuarter,
  useTextArea = false,
}: InputFieldProps) {
  return (
    <div className={styles.inputField} style={isQuarter ? { width: '25%', flex: 'none' } : {}}>
      <label htmlFor={id}>{label}</label>
      {useTextArea ? (
        <Input.TextArea
          className={styles.textareascrollbar}
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      ) : (
        <Input id={id} value={value} onChange={(e) => onChange(e.target.value)} />
      )}
    </div>
  )
}

export default InputField
